module.exports = __webpack_public_path__ + "static/media/갑산금대산.0a20ad3a.jpg";